import React from 'react';
import './LoadingState.css';

const LoadingState = ({
  title = 'Carregando...',
  subtitle = 'Preparando as informacoes',
  variant = 'page',
  bars = 3
}) => {
  const className = `loading-state-modern loading-state-modern--${variant}`;

  return (
    <div className={className} role="status" aria-live="polite">
      <div className="loading-state-modern__panel">
        <div className="loading-state-modern__ring" aria-hidden="true">
          <span />
        </div>
        <div className="loading-state-modern__content">
          <p className="loading-state-modern__title">{title}</p>
          {subtitle && <p className="loading-state-modern__subtitle">{subtitle}</p>}
        </div>
        <div className="loading-state-modern__skeleton" aria-hidden="true">
          {Array.from({ length: bars }).map((_, index) => (
            <span key={index} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default LoadingState;
